export const getTeamPlayerReferenceIds = (players: unknown): string[] => {
  if (!Array.isArray(players)) return [];

  return players
    .map((player) => {
      if (typeof player === 'string' || typeof player === 'number') return String(player);
      if (player && typeof player === 'object' && 'id' in player) {
        return String((player as { id?: unknown }).id ?? '');
      }
      return '';
    })
    .filter((playerId) => playerId.length > 0);
};
